import { render } from "./quitarUsuarioModal.vue?vue&type=template&id=61f96d56"
import script from "./quitarUsuarioModal.vue?vue&type=script&lang=js"
export * from "./quitarUsuarioModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__